export const theme_black_color = "#ff702e";
export const theme_white_color = "#008800";
export const theme_white_color_bg = "#00880014";
export const theme_black_color_bg = "#ff702f14";
export const theme_white_color_bg1 = "#00880014";
export const theme_black_color_bg1 = "#ff702f14";
export const theme_white_bg_color = "#eff6ed";
export const theme_black_bg_color = "#fff4ef";
export const white = '#ffffff';
export const black = "#000000";



export const theme_bg = "#ff702e";
export const theme_fg = "#008800";
export const theme_light = "#c9ddf5";
export const theme_fg_two = "#202028";
export const theme_bg_three = "#FFFFFF";
export const theme_fg_three = "#FFFFFF";

export const black_layer = "rgba(0, 0, 0, 0.5)"; 
export const grey = "#808080";
export const light_grey = "#f2f2f2";
export const light_green = "#e8faf1";
export const light_blue = "#326bd1";
export const light_yellow = "#fffde8";
export const light_red = "#fcdedc";
export const red = "#ff471a";
export const green = "green";
export const orange = "#FFA500";
export const blue = "blue";
export const theme_fg_yellow = "#eb9e3e";
export const theme_opactiy_bg = "#5d5953b8";
export const mid_green = "#70db70";

